import { omitCodelistContainerProps, pickCodelistContainerProps } from '@gef-ui/codelist/constants';
import CodelistContainer from '@gef-ui/codelist/containers/CodelistContainer';
import { SelectOption } from '@gef-ui/components/atoms/Select';
import Select from '@gef-ui/components/atoms/Select/Select';
import chainHandlers from "@gef-ui/utils/chainHandlers";
import T from "ramda/es/T";
import compose from "ramda/es/compose";
import curry from "ramda/es/curry";
import filter from "ramda/es/filter";
import map from "ramda/es/map";
import React from 'react';
import { fieldTypes, inputColor, validationColor } from '../../../../constants';
const defaultOption = (o)=>/*#__PURE__*/ React.createElement(SelectOption, {
        key: o.code,
        value: o.code,
        label: o.name
    });
const defaultCreateOptions = curry((f, o)=>compose(map(defaultOption), filter(f))(o));
const basicSelect = ({ selectProps, createOptions, optionsFilter, options })=>/*#__PURE__*/ React.createElement(Select, selectProps, createOptions(optionsFilter, options));
const codelistSelect = ({ selectProps, codelistContainerProps })=>/*#__PURE__*/ React.createElement(CodelistContainer, codelistContainerProps, /*#__PURE__*/ React.createElement(Select, selectProps));
export default ((fieldType)=>({ handleFocusFalse, handleFocusTrue, handleChange, displayValue, viewParser, errMeta, formName, handleUpdate, handleAsyncValidate, value, handleValidate, valid, errMessage, onChange, label, disabled, createOptions = defaultCreateOptions, optionsFilter = T, options, codelistName, fieldName, multiSelect, freetext, onBlur, onFocus, clearOnParentValueChange, ...other })=>{
        const selectProps = {
            id: fieldName,
            validationText: errMessage,
            floatingLabelText: label,
            controlClassName: inputColor(valid),
            validationClassName: validationColor(valid),
            value: multiSelect && !value ? [] : value,
            disabled,
            multiSelect,
            freetext,
            onInputChange: freetext && chainHandlers([
                handleUpdate,
                onChange
            ]),
            onFocus,
            onBlur: freetext ? chainHandlers([
                handleAsyncValidate,
                handleValidate,
                onBlur
            ]) : onBlur,
            onChange: chainHandlers([
                handleUpdate,
                handleAsyncValidate,
                handleValidate,
                onChange
            ]),
            ...omitCodelistContainerProps(other)
        };
        const codelistContainerProps = {
            ...pickCodelistContainerProps(other),
            convertDataIntoChildAcceptableFormat: createOptions(optionsFilter),
            name: codelistName,
            storeKey: codelistName,
            onCodelistClear: ()=>clearOnParentValueChange && chainHandlers([
                    handleUpdate,
                    onChange
                ])(null, '')
        };
        const createParams = {
            selectProps,
            codelistContainerProps,
            createOptions,
            optionsFilter,
            options
        };
        return fieldType === fieldTypes.SELECT ? basicSelect(createParams) : codelistSelect(createParams);
    });
